import React, { FaList, FaFolderPlus, FaUserCircle, FaTachometerAlt, FaSms } from "react-icons/fa";
import { BsGraphUpArrow, BsJournalText, BsCalendar4Week, BsGear, BsCashCoin, BsRulers } from "react-icons/bs";

// Access to pages also controlled on App.js

// User role IDs
const ALL_EMPLOYEEES = 10;
const MANAGER_AND_UP = 2;
const ADMIN_ONLY = 1;
const DEV_ONLY = 0

const links = [
  {
    id: 0,
    text: "Dashboard",
    path: "dashboard",
    icon: <FaTachometerAlt />,
    maxUserRolesId: ALL_EMPLOYEEES,
  },
  {
    id: 1,
    text: "All Jobs",
    path: "all-jobs",
    icon: <FaList />,
    maxUserRolesId: ALL_EMPLOYEEES,
  },
  {
    id: 2,
    text: "Add Job",
    path: "add-job",
    icon: <FaFolderPlus />,
    maxUserRolesId: MANAGER_AND_UP,
  },
  {
    id: 3,
    text: "Job Summary",
    path: "job-summary",
    icon: <BsJournalText />,
    maxUserRolesId: ALL_EMPLOYEEES,
    dbTables: ["job", "address", "customer", "contacts"]
  },
  {
    id: 10,
    text: "Messages",
    path: "messages",
    icon: <FaSms />,
    maxUserRolesId: DEV_ONLY,
  },
  {
    id: 4,
    text: "Work Specs",
    path: "work-specs",
    icon: <BsRulers />,
    maxUserRolesId: ALL_EMPLOYEEES,
    dbTables: ["options", "fees", "discounts", "warranties"]
  },
  {
    id: 5,
    text: "Appointments",
    path: "appointments",
    icon: <BsCalendar4Week />,
    maxUserRolesId: MANAGER_AND_UP,
    dbTables: ["appointments"]
  },
  {
    id: 6,
    text: "Payments",
    path: "payments",
    icon: <BsCashCoin />,
    maxUserRolesId: MANAGER_AND_UP,
    dbTables: ["payments"]
  },
  { id: 7, text: "Reports", path: "reports", icon: <BsGraphUpArrow />, maxUserRolesId: ADMIN_ONLY },
  { id: 8, text: "Admin", path: "admin", icon: <BsGear />, maxUserRolesId: ADMIN_ONLY },
  {
    id: 9,
    text: "User Settings",
    path: "user-settings",
    icon: <FaUserCircle />,
    maxUserRolesId: ALL_EMPLOYEEES,
  },
];

export default links;
